import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";

import SinglesHeader from "../../partials/singlesHeader";
import { getEntityCategories } from "../../partials/posts/postHelpers";
import CompanyappLoader from "../../partials/companyappLoader";
import {
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  Button,
} from "@mui/material";
import { Row, Col } from "react-bootstrap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AlertModal from "../../partials/alertModal";
import UndoIcon from "@mui/icons-material/Undo";

const TYPES = [
  {
    typeName: "news",
    typeLabel: "News categories",
    targetVid: "news_categories",
  },
  {
    typeName: "event",
    typeLabel: "Events categories",
    targetVid: "event_categories",
  },
  {
    typeName: "presentation",
    typeLabel: "Presentations categories",
    targetVid: "presentation_categories",
  },
  {
    typeName: "video",
    typeLabel: "Videos categories",
    targetVid: "video_categories",
  },
  {
    typeName: "gallery",
    typeLabel: "Galleries categories",
    targetVid: "gallery_categories",
  },
  {
    typeName: "podcast",
    typeLabel: "Podcasts categories",
    targetVid: "podcast_categories",
  },
  {
    typeName: "document",
    typeLabel: "Documents categories",
    targetVid: "document_categories",
  },
  {
    typeName: "training",
    typeLabel: "Training Courses categories",
    targetVid: "training_categories",
  },
  {
    typeName: "quiz",
    typeLabel: "Quizzes categories",
    targetVid: "quiz_categories",
  },
  {
    typeName: "link",
    typeLabel: "Links categories",
    targetVid: "link_categories",
  },
];
export default function TermSingle(props) {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [parentTerm, setParentTerm] = useState(0);
  const [weight, setWeight] = useState("0");
  const [showAlert, setShowAlert] = useState(false);
  const [modalOptions, setModalOptions] = useState({});

  const user = useSelector((state) => state.authReducer.user);
  const navigate = useNavigate();
  const params = useParams();
  const vid = params.vid;
  const tid = params?.tid;

  useEffect(() => {
    getEntityCategories({
      user,
      setCategories,
      targetVid: vid,
      setIsLoading,
    });
  }, []);

  useEffect(() => {
    if (categories.length > 0) {
      setTitle(categories.find((item) => item.tid === tid)?.title);
    }
  }, [categories]);

  const startDelete = (id) => {
    setModalOptions({
      alertType: "warning",
      alertMessageTitle: "Are you sure?",
      alertMessageBody: "Are you sure you want to delete this category term?",
      cancelButton: true,
      cancelButtonLabel: "Cancel",
      confirmButton: true,
      confirmButtonLabel: "Delete",
      confirmButtonColor: "error",
      onConfirm: () => {
        setShowAlert(false);
      },
      showAlertCallback: () => {
        setShowAlert(false);
      },
    });
    setShowAlert(true);
  };

  return (
    <>
      {isLoading ? (
        <CompanyappLoader />
      ) : (
        <main className={`term single`} data-id={tid}>
          <article className="article">
            <SinglesHeader
              route={`/taxonomies/${vid}`}
              backBtnText={`${TYPES.find((item) => item.targetVid === vid).typeLabel}`}
              hash={null}
            />
            <TextField
              label={
                <Typography
                  owner="client"
                  family="secondary"
                  variant="body1"
                  weight="semiBold"
                  color="clientPrimary.main"
                >
                  Title
                </Typography>
              }
              className="post-title-edit w-100 mb-4"
              owner="client"
              variant="standard"
              value={title}
              family="secondary"
              textvariant="h1"
              onInput={(e) => setTitle(e.target.value)}
            />
            <TextField
              label={
                <Typography
                  owner="client"
                  family="secondary"
                  variant="body1"
                  weight="semiBold"
                  color="clientPrimary.main"
                >
                  Description
                </Typography>
              }
              className="mb-4 w-100"
              variant="outlined"
              value={description}
              multiline
              minRows={4}
              textvariant="body2"
              onInput={(e) => setDescription(e)}
            />

            <FormControl className="mb-4" fullWidth>
              <InputLabel id="group-select-label">
                <Typography
                  owner="client"
                  family="secondary"
                  variant="body1"
                  weight="semiBold"
                  color="clientPrimary.main"
                >
                  Group
                </Typography>
              </InputLabel>
              <Select
                labelId="group-select-label"
                id="group-select"
                value={0}
                label="Group"
              >
                <MenuItem value={0}>-None-</MenuItem>
                <MenuItem value={1}>Administrative</MenuItem>
                <MenuItem value={2}>Editorial</MenuItem>
              </Select>
            </FormControl>

            <FormControl className="mb-4" fullWidth>
              <InputLabel id="space-select-label">
                <Typography
                  owner="client"
                  family="secondary"
                  variant="body1"
                  weight="semiBold"
                  color="clientPrimary.main"
                >
                  Space
                </Typography>
              </InputLabel>
              <Select
                labelId="space-select-label"
                id="space-select"
                value={0}
                label="Space"
              >
                <MenuItem value={0}>-None-</MenuItem>
              </Select>
            </FormControl>

            <Accordion elevation={1} className="mb-4">
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  owner="client"
                  family="secondary"
                  variant="body1"
                  weight="semiBold"
                  color="clientPrimary.main"
                >
                  Relations
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <FormControl className="mb-4" fullWidth>
                  <InputLabel id="space-select-label">
                    <Typography
                      owner="client"
                      family="secondary"
                      variant="body1"
                      weight="semiBold"
                      color="clientPrimary.main"
                    >
                      Parent terms
                    </Typography>
                  </InputLabel>
                  <Select
                    labelId="space-select-label"
                    id="space-select"
                    value={parentTerm}
                    label="Space"
                    onChange={(event) => {
                      setParentTerm(event.target.value);
                    }}
                  >
                    <MenuItem value={0}>-root-</MenuItem>
                    {categories
                      .filter((item) => item.value !== 0)
                      .map((_item) => (
                        <MenuItem value={_item.value}>{_item.label}</MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <TextField
                  label={
                    <Typography
                      owner="client"
                      family="secondary"
                      variant="body1"
                      weight="semiBold"
                      color="clientPrimary.main"
                    >
                      Weight
                    </Typography>
                  }
                  className="mb-4 w-100"
                  helperText="Terms are displayed in ascending order by weight."
                  variant="outlined"
                  value={weight}
                  textvariant="body2"
                  onInput={(e) => setWeight(e)}
                />
              </AccordionDetails>
            </Accordion>

            <FormControlLabel
              className="mb-4"
              control={<Checkbox defaultChecked />}
              label={
                <Typography
                  owner="client"
                  family="secondary"
                  variant="body1"
                  weight="semiBold"
                  color="clientPrimary.main"
                >
                  Published
                </Typography>
              }
            />
            <Row className="d-flex justify-content-between">
              <Col xs="auto">
                {!props.add && (
                  <Button
                    className="h-100 term-single-action-btn"
                    owner="admin"
                    color="error"
                    variant="contained"
                    startIcon={<DeleteOutlinedIcon />}
                    onClick={() => startDelete()}
                  >
                    <Typography owner="client" variant="button">
                      Delete
                    </Typography>
                  </Button>
                )}
              </Col>
              <Col xs="auto">
                <Row>
                  <Col xs="auto">
                    <Button
                      className="h-100 term-single-action-btn"
                      owner="admin"
                      color="primary"
                      variant="outlined"
                      startIcon={<UndoIcon />}
                      onClick={() => navigate(`/taxonomies/${vid}`)}
                    >
                      <Typography owner="client" variant="button">
                        Cancel
                      </Typography>
                    </Button>
                  </Col>
                  <Col xs="auto">
                    <Button
                      className="h-100 term-single-action-btn"
                      owner="admin"
                      color="primary"
                      variant="contained"
                      startIcon={<SaveOutlinedIcon />}
                    >
                      <Typography owner="client" variant="button">
                        Save
                      </Typography>
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <AlertModal
              showAlert={showAlert}
              showCaLogo={true}
              {...modalOptions}
            />
          </article>
        </main>
      )}
    </>
  );
}
